import React, { useMemo } from "react";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  useTheme,
  Chip,
  IconButton,
  Button,
  Box,
} from "@mui/material";
import _ from "lodash";
import { IconInfoCircle } from "@tabler/icons";
import SimpleModal from "components/tables/stations/modal/Modal.component";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import DialogComponent from "components/dialog/Dialog.component";

import { useTranslation } from "react-i18next";
import HeadComponent from "../list/list-head/Head.component";

const IdSensorsTable = ({
  rows,
  onClickAdd = () => { },
  isSuperUser,
  handleDeletesensor = () => { },
  stationId,
  handleOpen = () => { },
  handleClose = () => { },
  openModal,
  setIsChageStatusSensor = () => { },
  isChageStatusSensor
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const TABLE_HEAD = useMemo(
    () => [
      {
        id: "sensorId",
        label: t("Sensors ID"),
        alignRight: false,
        order: true,
      },
      { id: "info", label: "", alignRight: false, order: true },
      { id: "delete", label: "", alignRight: false, order: true },
    ],
    [t]
  );

  return (
    <TableContainer>
      {isSuperUser && (
        <Box sx={{ width: "100%", justifyContent: "end", display: "flex" }}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={onClickAdd}
          >
            {t("Add Sensor")}
          </Button>
        </Box>
      )}
      <Table size="small" aria-label="purchases">
        <HeadComponent header={TABLE_HEAD} sx={{ fontSize: 12 }} />

        <TableBody>
          {rows && !_.isEmpty(rows) ? (
            rows.map((item, index) => (
              <TableRow
                key={index}
                sx={{
                  height: 43.3,
                  "&:last-child td, &:last-child th": {
                    border: 0,
                  },
                }}
              >
                <TableCell
                  align="left"
                  sx={{ width: '1px', whiteSpace: 'nowrap' }}
                >{item}</TableCell>
                <TableCell align="left">
                  <IconButton onClick={() => handleOpen(item)}>
                    <IconInfoCircle
                      style={{
                        color:
                          theme.palette.mode === "dark"
                            ? theme.palette.secondary.main
                            : theme.palette.primary.main,
                      }}
                    />
                  </IconButton>

                  {!!openModal && (
                    <SimpleModal
                      id={item}
                      open={openModal}
                      handleClose={handleClose}
                      handleOpen={handleOpen}
                      setIsChageStatusSensor={setIsChageStatusSensor}
                      isChageStatusSensor={isChageStatusSensor}
                    />
                  )}
                </TableCell>

                <TableCell align="right" sx={{ cursor: "pointer" }}>
                  {isSuperUser && (
                    <DialogComponent
                      content={t(
                        "Are you sure you want to proceed with the deletion?"
                      )}
                      button={
                        <IconButton size="large">
                          <DeleteTwoToneIcon
                            style={{
                              color:
                                theme.palette.mode === "dark"
                                  ? theme.palette.secondary.main
                                  : theme.palette.primary.main,
                            }}
                          />
                        </IconButton>
                      }
                      onClickYes={() =>
                        handleDeletesensor({
                          station_id: stationId,
                          sensor_id: item,
                        })
                      }
                    />
                  )}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow
              sx={{
                height: 43.3,
                "&:last-child td, &:last-child th": {
                  border: 0,
                },
              }}
            >
              <TableCell align="left">
                <Chip label={t("None")} size="small" chipcolor="orange" />
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default IdSensorsTable;
